import { Col, Row } from 'antd';
import React from 'react';
import Button from '../button';
import Wrapper from './style';

const Index = (props) => {
  const {
    title,
    titleIcon,
    desc,
    color,
    showBtn,
    btnText = 'Get Started',
    onClickButton,
    btnType = 'secondary',
  } = props;
  return (
    <Wrapper color={color}>
      <Row gutter={[12, 12]}>
        <Col
          span={24}
          className="font-caption_medium black1 component_information_card_title"
        >
          {titleIcon && titleIcon}
          {title}
        </Col>
        {desc && <Col className="font-caption black2">{desc}</Col>}
        {showBtn && (
          <Col>
            <Button type={btnType} onClick={onClickButton} htmlType="button">
              {btnText}
            </Button>
          </Col>
        )}
      </Row>
    </Wrapper>
  );
};

export default Index;
